import introJs from 'intro.js'
import 'intro.js/introjs.css'
import { useHasModule } from '@/composables/hasModule'

const { hasModule } = useHasModule()

function buildSteps() {
  return [
    {
      key: 'welcome',
      title: i18n.global.t('navigation.welcome'),
      intro: `<div style="text-align: center;">
                  <img src="/assets/media/logos/qomerxia-logo.png" style="max-width: 100%;" />
                  <h1 style="margin-top: 10px; margin-bottom: 10px;">${i18n.global.t('navigation.welcome')}! 👋</h1>
                  <p style="font-size: 17px;">${i18n.global.t('introjsBulle.welcome.message')}</p>
                </div>
            `,
      disablePrev: true,
    },
    {
      key: 'dashboard',
      title: i18n.global.t('navigation.dashboard'),
      intro: `<p>${i18n.global.t('introjsBulle.dashboard.texte')}</p>
              <ul>
                <li>${i18n.global.t('introjsBulle.dashboard.fonctionnalite1')}</li>
                <li>${i18n.global.t('introjsBulle.dashboard.fonctionnalite2')}</li>
                <li>${i18n.global.t('introjsBulle.dashboard.fonctionnalite3')}</li>
                <li>${i18n.global.t('introjsBulle.dashboard.fonctionnalite4')}</li>
                <li>${i18n.global.t('introjsBulle.dashboard.fonctionnalite5')}</li>
                <li>${i18n.global.t('introjsBulle.dashboard.fonctionnalite6')}</li>
              </ul>
                  `,
      element: document.querySelector('body #step-dashboard')
    },
    {
      key: 'articles',
      title: i18n.global.t('introjsBulle.articles.title'),
      intro: `<p>${i18n.global.t('introjsBulle.articles.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.articles.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.articles.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.articles.fonctionnalite3')}</li>
                  <li>${i18n.global.t('introjsBulle.articles.fonctionnalite4')}</li>
              </ul>
            `,
      element: document.querySelector('body #step-articles')
    },
    {
      key: 'shop',
      title: i18n.global.t('navigation.shop'),
      intro: `<p>${i18n.global.t('introjsBulle.shop.texte')}</p>
              <ul>
                <li>${i18n.global.t('introjsBulle.shop.fonctionnalite1')}</li>
                <li>${i18n.global.t('introjsBulle.shop.fonctionnalite2')}</li>
                <li>${i18n.global.t('introjsBulle.shop.fonctionnalite3')}</li>
                <li>${i18n.global.t('introjsBulle.shop.fonctionnalite4')}</li>
                <li>${i18n.global.t('introjsBulle.shop.fonctionnalite5')}</li>
                <li>${i18n.global.t('introjsBulle.shop.fonctionnalite6')}</li>
                <li>${i18n.global.t('introjsBulle.shop.fonctionnalite7')}</li>
              </ul>
                  `,
      element: document.querySelector('body #step-shops'),
      position: 'bottom'
    },
    {
      key: 'promotions',
      title: i18n.global.t('introjsBulle.promotions.title'),
      intro: `<p>${i18n.global.t('introjsBulle.promotions.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.promotions.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.promotions.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.promotions.fonctionnalite3')}</li>
              </ul>
            `,
      element: document.querySelector('body #step-promotion')
    },
    {
      key: 'loyalty',
      title: i18n.global.t('introjsBulle.loyalty.title'),
      intro: `<p>${i18n.global.t('introjsBulle.loyalty.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.loyalty.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.loyalty.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.loyalty.fonctionnalite3')}</li>
              </ul>
            `,
      element: document.querySelector('body #step-loyalty')
    },
    {
      key: 'promo',
      title: i18n.global.t('introjsBulle.promo.title'),
      intro: `<p>${i18n.global.t('introjsBulle.promo.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.promo.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.promo.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.promo.fonctionnalite3')}</li>
              </ul>
            `,
      element: document.querySelector('body #step-promo')
    },
    {
      key: 'suppliers',
      title: i18n.global.t('introjsBulle.suppliers.title'),
      intro: `<p>${i18n.global.t('introjsBulle.suppliers.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.suppliers.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.suppliers.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.suppliers.fonctionnalite3')}</li>
              </ul>
            `,
      element: document.querySelector('body #step-suppliers')
    },
    {
      key: 'contact',
      title: i18n.global.t('navigation.contact'),
      intro: `<p>${i18n.global.t('introjsBulle.contact.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.contact.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.contact.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.contact.fonctionnalite3')}</li>
                  <li>${i18n.global.t('introjsBulle.contact.fonctionnalite4')}</li>
                  <li>${i18n.global.t('introjsBulle.contact.fonctionnalite5')}</li>
              </ul>
            `,
      element: document.querySelector('body #step-contacts')
    },
    {
      key: 'ecommerce',
      title: i18n.global.t('introjsBulle.ecommerce.title'),
      intro: `<p>${i18n.global.t('introjsBulle.ecommerce.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.ecommerce.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.ecommerce.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.ecommerce.fonctionnalite3')}</li>
                  <li>${i18n.global.t('introjsBulle.ecommerce.fonctionnalite4')}</li>
              </ul>
            `,
      element: document.querySelector('body #step-commandes')
    },
    {
      key: 'pos',
      title: i18n.global.t('introjsBulle.pos.title'),
      intro: `<p>${i18n.global.t('introjsBulle.pos.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.pos.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.pos.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.pos.fonctionnalite3')}</li>
              </ul>
            `,
      element: document.querySelector('body #step-pos')
    },
    {
      key: 'statisitique',
      title: i18n.global.t('introjsBulle.statisitique.title'),
      intro: `<p>${i18n.global.t('introjsBulle.statisitique.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.statisitique.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.statisitique.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.statisitique.fonctionnalite3')}</li>
                  <li>${i18n.global.t('introjsBulle.statisitique.fonctionnalite4')}</li>
                  <li>${i18n.global.t('introjsBulle.statisitique.fonctionnalite5')}</li>
                  <li>${i18n.global.t('introjsBulle.statisitique.fonctionnalite6')}</li>
                  <li>${i18n.global.t('introjsBulle.statisitique.fonctionnalite7')}</li>
                  <li>${i18n.global.t('introjsBulle.statisitique.fonctionnalite8')}</li>
                  <li>${i18n.global.t('introjsBulle.statisitique.fonctionnalite9')}</li>
                  <li>${i18n.global.t('introjsBulle.statisitique.fonctionnalite10')}</li>
              </ul>`,
      element: document.querySelector('body #step-statistique')
    },
    {
      key: 'rapports',
      title: i18n.global.t('introjsBulle.rapports.title'),
      intro: `<p>${i18n.global.t('introjsBulle.rapports.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.rapports.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.rapports.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.rapports.fonctionnalite3')}</li>
                  <li>${i18n.global.t('introjsBulle.rapports.fonctionnalite4')}</li>
              </ul>
            `,
      element: document.querySelector('body #step-rapports')
    },
    {
      key: 'settings',
      title: i18n.global.t('navigation.setting'),
      intro: `
                  <p>${i18n.global.t('introjsBulle.settings.texte')}</p>
                  <ul>
                      <li><h4>${i18n.global.t('introjsBulle.settings.settings1')}</h4></li>
                      <li><h4>${i18n.global.t('introjsBulle.settings.settings2')}</h4></li>
                      <li><h4>${i18n.global.t('introjsBulle.settings.settings3')}</h4></li>
                    </ul>
                `,
      element: document.querySelector('body #step-settings'),
      position: 'right'
    },
    {
      key: 'settings_ecommerce',
      module: 'ecommerce',
      title: i18n.global.t('introjsBulle.settings_ecommerce.title'),
      intro: `
                  <p>${i18n.global.t('introjsBulle.settings_ecommerce.texte')}</p>
                  <ul>
                    <li>${i18n.global.t('introjsBulle.settings_ecommerce.fonctionnalite1')}</li>
                    <li>${i18n.global.t('introjsBulle.settings_ecommerce.fonctionnalite2')}</li>
                    <li>${i18n.global.t('introjsBulle.settings_ecommerce.fonctionnalite3')}</li>
                    <li>${i18n.global.t('introjsBulle.settings_ecommerce.fonctionnalite4')}</li>
                  </ul>
                `,
      element: document.querySelector('body #step-settings'),
      position: 'right'
    },
    {
      key: 'settings_user',
      title: i18n.global.t('introjsBulle.settings_user.title'),
      intro: `
                  <p>${i18n.global.t('introjsBulle.settings_user.texte')}</p>
                  <ul>
                    <li>${i18n.global.t('introjsBulle.settings_user.fonctionnalite1')}</li>
                    <li>${i18n.global.t('introjsBulle.settings_user.fonctionnalite2')}</li>
                    <li>${i18n.global.t('introjsBulle.settings_user.fonctionnalite3')}</li>
                  </ul>
                `,
      element: document.querySelector('body #step-settings'),
      position: 'right'
    },
    {
      key: 'settings_system',
      title: i18n.global.t('introjsBulle.settings_system.title'),
      intro: `
                  <p>${i18n.global.t('introjsBulle.settings_system.texte')}</p>
                  <ul>
                    <li>${i18n.global.t('introjsBulle.settings_system.fonctionnalite1')}</li>
                  </ul>
                `,
      element: document.querySelector('body #step-settings'),
      position: 'right'
    },
    {
      key: 'information',
      title: i18n.global.t('introjsBulle.information.title'),
      intro: `<p>${i18n.global.t('introjsBulle.information.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.information.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.information.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.information.fonctionnalite3')}</li>
              </ul>
            `,
      element: document.querySelector('body #step-information')
    },
    {
      key: 'profil',
      title: i18n.global.t('navigation.profil'),
      intro: `<p>${i18n.global.t('introjsBulle.profil.texte')}</p>
              <ul>
                  <li>${i18n.global.t('introjsBulle.profil.fonctionnalite1')}</li>
                  <li>${i18n.global.t('introjsBulle.profil.fonctionnalite2')}</li>
                  <li>${i18n.global.t('introjsBulle.profil.fonctionnalite3')}</li>
                  <li>${i18n.global.t('introjsBulle.profil.fonctionnalite4')}</li>
              </ul>`,
      element: document.querySelector('body #step-profil')
    }
  ].filter(step => (step.key === 'welcome' || step.key === 'settings' || step.element) && (!step.module || hasModule(step.module)))
}

export function buildOnboardingOptions() {
  return {
    exitOnEsc: true,
    exitOnOverlayClick: false,
    showButtons: true,
    scrollToElement: true,
    nextLabel: i18n.global.t('introjsBulle.nextLabel'),
    prevLabel: i18n.global.t('introjsBulle.prevLabel'),
    doneLabel: i18n.global.t('introjsBulle.doneLabel'),
    tooltipClass: 'custom-tooltip-class',
    buttonClass: 'btn btn-primary btn-sm',
    onbeforechange: function (targetElement) {
      if (targetElement.id === 'step-shops') {
        window.location.href = '/admin/settings-index/items'
        return false
      }
    },
    steps: buildSteps()
  }
}

export function startOnboardingTour(fromKey = null) {
  const options = buildOnboardingOptions()
  const intro = introJs()
  intro.setOptions(options)
  intro.start()
  if (fromKey) {
    const index = options.steps.findIndex(step => step.key === fromKey)
    if (index > -1) {
      intro.goToStep(index + 1)
    }
  }
  return intro
}
